import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
//import { gaWrapper } from 'helpers/analytics';
// import { format, register } from 'timeago.js';
import Link from 'components/Link';
import Image from 'components/Image';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './videocard.scss';
import search from './videocard_search.scss';
import searchRightTopvideos from './videocard_search_right_topvideos.scss';
import { rodate } from '../../utils/common';

class Videocard extends React.Component {
  static isLatestVideo(latestDateObject = {}) {
    if (
      latestDateObject.getTime &&
      new Date().getTime() - latestDateObject.getTime() < 3600 * 1000
    ) {
      return true;
    }
    return false;
  }

  clickHandler(e, index) {
    const { data, categoryType } = this.props;
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: this.props.name,
      label: data?.wu,
      video_no: Number(index),
      msid: data?.id,
      playlist_name: this.props.secName,
      category: `${categoryType} clicked`,
    });
  }
  render() {
    const { data, theme, ext } = this.props;
    let styleObject = s;
    if (theme === 'search') {
      styleObject = search;
    }
    if (theme === 'topvideo_horizontal') {
      styleObject = searchRightTopvideos;
    }
    let imgSrc = 'https://static.toiimg.com/photo/34824568.cms';
    let imgElements;
    if (data.imageid) {
      imgElements = data.imageid.split('&');
      if (imgElements.length > 1) {
        imgSrc = `https://static.toiimg.com/thumb/msid-${imgElements[0]},${
          imgElements[1]
        },width-280,resizemode-4/${imgElements[0]}.jpg`;
      } else {
        imgSrc = `https://static.toiimg.com/photo/msid-${
          imgElements[0]
        },width-280,resizemode-4/${imgElements[0]}.jpg`;
      }
    } else {
      imgSrc = `https://static.toiimg.com/photo/msid-${
        data.id
      },width-280,resizemode-4/${data.id}.jpg`;
    }
    let { views } = data;
    if (views && views !== '') {
      views += ' views';
    }
    let description = '';
    if (data.dc) {
      description = <p className={styleObject.description}>{data.dc}</p>;
    }
    let linkUrl = data.wu || data.su;
    if (
      this.props.viewMoreCard &&
      this.props.isWapView &&
      this.props.parentPath !== this.props.viewMoreCardPath
    ) {
      linkUrl = this.props.viewMoreCardPath;
    }

    const latestDate = data.upd || data.lpt || data.dl;
    // if (latestDate) {
    const latestDateObject =
      parseInt(latestDate, 10) > 100000000
        ? new Date(parseInt(latestDate, 10))
        : new Date(latestDate);
    const latestDateRelativeString = rodate(latestDate);
    const isLatestVideo = Videocard.isLatestVideo(latestDateObject);
    // let specialCardClass = '';
    // if (this.props.sliderBetweenList) {
    //   specialCardClass = s['special-card-item'];
    // }
    // let viewMoreCardClass = '';
    // if (this.props.viewMoreCard) {
    //   viewMoreCardClass = 'view-more-card';
    // }
    const videoCardClass = classNames({
      [`${styleObject.cardItem}`]: !this.props.isEtimesVs,
      [`${styleObject.cardItemVs}`]: this.props.isEtimesVs,
      [`${styleObject.iconNotRequired}`]: this.props.categoryType,
      [`${styleObject[this.props.theme]}`]: this.props.theme !== 'default',
      [`${s['special-card-item']}`]: this.props.sliderBetweenList,
      [`${s['view-more-card']}`]:
        this.props.viewMoreCard &&
        this.props.parentPath !== this.props.viewMoreCardPath,
      [`${s['language-card']}`]: this.props.language,
    });
    // }
    return (
      <div
        className={`${videoCardClass} ${data.primeid ? s.prime : ''}`}
        key={data.id}
      >
        <figure className={styleObject.image}>
          <Link
            to={linkUrl}
            className={styleObject.content}
            title={data.hl}
            data-newga={`${this.props.eventForGA}-${linkUrl}`}
            ext={ext}
            // onClick={e => {
            //   this.clickHandler(e, this.props.index, data);
            // }}
            ga4Data={[
              {
                event: 'user_click',
                type: this.props.name,
                label: data?.wu,
                video_no: Number(this.props.index),
                msid: data?.id,
                playlist_name: this.props.name,
                category: `${this.props.categoryType} clicked`,
              },
            ]}
          >
            <Image
              src={imgSrc}
              alt={data.hl}
              lazyload
              placeHolderSrc="https://static.toiimg.com/photo/34824568.cms"
              offsetVertical={100}
            />
            {this.props.viewMoreCard &&
            this.props.parentPath !== this.props.viewMoreCardPath ? (
              <div className={styleObject.view_more_title}>
                View more {this.props.name} videos
              </div>
            ) : null}
            {!this.props.isWapView ? <div className={s.dummyDiv} /> : null}
          </Link>
          {!this.props.viewMoreCard ? (
            <span className={styleObject.duration}>{data.du}</span>
          ) : null}
        </figure>
        {!(
          this.props.viewMoreCard &&
          this.props.parentPath !== this.props.viewMoreCardPath
        ) ? (
          <Link
            className={styleObject.title}
            to={linkUrl}
            title={data.hl}
            data-newga={`${this.props.eventForGA}-${linkUrl}`}
            ext={ext}
          >
            {data.hl}
            {data.icon === 'smiley' ? (
              <img
                className="humour-emoji"
                src="https://static.toiimg.com/photo/50686029.cms"
                alt="Smiley"
              />
            ) : null}
          </Link>
        ) : null}
        {!this.props.isWapView ? (
          <footer className={styleObject.footer}>
            {views &&
              parseInt(views, 10) >= 100 && (
                <span className={styleObject.views}>{views}</span>
              )}
            {/* <span className={styleObject.time}>5 hours ago</span> */}
            {latestDate &&
              latestDateRelativeString && (
                <span
                  className={`${styleObject.time} ${
                    isLatestVideo ? s.redColor : ''
                  }`}
                >
                  {latestDateRelativeString}
                </span>
              )}
            {description}
          </footer>
        ) : null}
      </div>
    );
  }
}

Videocard.propTypes = {
  data: PropTypes.shape({}).isRequired,
  theme: PropTypes.string.isRequired,
  sliderBetweenList: PropTypes.bool,
  // spa: PropTypes.bool.isRequired,
  isWapView: PropTypes.bool,
  ext: PropTypes.bool,
  viewMoreCard: PropTypes.bool,
  viewMoreCardPath: PropTypes.string,
  parentPath: PropTypes.string,
  language: PropTypes.string,
  eventForGA: PropTypes.string,
  name: PropTypes.string,
  categoryType: PropTypes.string,
  isEtimesVs: PropTypes.bool,
  index: PropTypes.number,
  secName: PropTypes.string,
};

Videocard.defaultProps = {
  sliderBetweenList: false,
  isWapView: false,
  parentPath: '',
  viewMoreCard: false,
  viewMoreCardPath: '',
  language: '',
  eventForGA: '',
  name: '',
  ext: '',
  categoryType: '',
  isEtimesVs: false,
  index: 0,
  secName: '',
};

export default Videocard;
